// Stable "highlighted ids first" reorder for the family workspace grid, used
// once right after a family merge so the just-moved variants surface at the
// top of the target family's rows. Pure reorder only — no items are added,
// removed, or mutated, so it's safe to recompute on every render without
// ever marking a row dirty (highlight is presentation-only, never part of
// the row model).
export function sortHighlightedFirst<T>(
  items: T[],
  getId: (item: T) => number,
  highlightedIds: ReadonlySet<number> | undefined
): T[] {
  if (!highlightedIds || highlightedIds.size === 0) return items;

  const highlighted: T[] = [];
  const rest: T[] = [];
  for (const item of items) {
    (highlightedIds.has(getId(item)) ? highlighted : rest).push(item);
  }
  return [...highlighted, ...rest];
}
